import {SvgIcon} from "@material-ui/core";

export const CustomSidebarBackgroundIcon = (props) => {
    return (
        <SvgIcon width="193" height="366" viewBox="0 0 193 366" fill="#501F86" {...props}>
            <path opacity="0.3" d="M273.293 206.931C272.93 207.713 236.954 285.559 236.935 365.427H205.099C205.099 293.685 230.831 225.491 240.712 201.99L151.02 73.385V194.932C166.09 200.102 176.924 214.389 176.886 231.213C176.81 252.33 159.642 269.402 138.526 269.345C117.41 269.268 100.337 252.101 100.414 230.985C100.471 214.256 111.287 200.102 126.28 194.951V73.4423L36.569 202.028C46.4309 225.548 72.1443 293.723 72.1443 365.465H40.3077C40.3077 285.826 4.35094 207.751 3.98852 206.988L0.097168 198.671L138.679 0.0407715L277.222 198.652L273.331 206.969L273.293 206.931Z"/>
        </SvgIcon>
    )
}
